var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "clipboard-composer" }, [
    _c("div", { staticClass: "clipboard-composer__row" }, [
      _c(
        "select",
        {
          staticClass: "clipboard-composer__type-select",
          attrs: { "aria-label": "Item type" },
          domProps: { value: _vm.effectiveType },
          on: { change: _vm.onTypeChange },
        },
        _vm._l(_vm.typeOptions, function (t) {
          return _c("option", { key: t.value, domProps: { value: t.value } }, [
            _vm._v("\n        " + _vm._s(t.label) + "\n      "),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("input", {
        staticClass: "clipboard-composer__label-input",
        attrs: {
          type: "text",
          placeholder: _vm.config.labelPlaceholder,
          maxlength: "255",
        },
        domProps: { value: _vm.form.title },
        on: { input: _vm.onTitleInput },
      }),
    ]),
    _vm._v(" "),
    _vm.config.bulkPaste
      ? _c(
          "button",
          {
            staticClass: "clipboard-composer__bulk-toggle",
            attrs: { type: "button" },
            on: { click: _vm.toggleBulkPaste },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "12",
                  height: "12",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                },
              },
              [
                _c("rect", {
                  attrs: { width: "18", height: "18", x: "3", y: "3", rx: "2" },
                }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M21 9H3" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M21 15H3" } }),
              ]
            ),
            _vm._v(
              "\n    " +
                _vm._s(_vm.bulkPaste ? "Bulk paste on" : "Bulk paste off") +
                "\n  "
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.useMultiline
      ? _c("textarea", {
          ref: "contentField",
          staticClass:
            "clipboard-composer__content clipboard-composer__content--area",
          attrs: {
            placeholder: _vm.contentPlaceholder,
            maxlength: "10000",
            rows: "3",
          },
          domProps: { value: _vm.form.content },
          on: {
            input: _vm.onContentInput,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              )
                return null
              $event.preventDefault()
              return _vm.submitOnEnter.apply(null, arguments)
            },
          },
        })
      : _c("input", {
          ref: "contentField",
          staticClass:
            "clipboard-composer__content clipboard-composer__content--input",
          class: { "clipboard-composer__content--mono": _vm.config.mono },
          attrs: {
            type: "text",
            placeholder: _vm.contentPlaceholder,
            maxlength: "10000",
          },
          domProps: { value: _vm.form.content },
          on: {
            input: _vm.onContentInput,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
              return _vm.submitOnEnter.apply(null, arguments)
            },
          },
        }),
    _vm._v(" "),
    _c("div", { staticClass: "clipboard-composer__actions" }, [
      _c(
        "button",
        {
          staticClass: "clipboard-composer__btn clipboard-composer__btn--ghost",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("cancel")
            },
          },
        },
        [_vm._v("\n      Cancel\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "clipboard-composer__btn clipboard-composer__btn--primary",
          attrs: { type: "button", disabled: !_vm.canSave || _vm.saving },
          on: {
            click: function ($event) {
              return _vm.$emit("save")
            },
          },
        },
        [
          _vm.saving
            ? _c("span", [_vm._v("Saving…")])
            : _c("span", [_vm._v("Save")]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }